import { observable } from 'mobx';
import { createRef } from 'react';
import useMount from '@src/utils/hooks/use-mount';

export default class Store {
  @observable isShowCover = true; // 是否显示封面
  @observable isPlaying = false; // 是否播放中

  onCanPlayThrough = () => {
    this.isShowCover = false;
    this.play();
  };

  replay = () => {
    if (this.ref.current) {
      this.ref.current.currentTime = 0;
    }
    this.isShowCover = false;
    this.play();
  };

  // 停止播放视频后，重新展示封面kv
  stop = () => {
    this.pause();
    this.isShowCover = true;
  };

  play = () => {
    if (this.isShowCover) {
      return;
    }
    this.ref.current?.play();
    this.isPlaying = true;
  };

  pause = () => {
    this.ref.current?.pause();
    this.isPlaying = false;
  };

  use() {
    this.ref = createRef();

    useMount(() => {});
  }
}
